import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dir"]

import { computed } from 'vue';
import useLocale from '@/util/locale';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { selectedLocaleId } = useLocale();

const direction = computed(() => (selectedLocaleId.value === 'ar' ? 'rtl' : 'ltr'));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", { dir: direction.value }, [
    _createVNode(_component_router_view)
  ], 8, _hoisted_1))
}
}

})